/**
 * Audit Findings Page - ComplyIQ
 *
 * Stub page for managing audit findings and remediation.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Shield, Plus, Search, Filter, Download } from 'lucide-react'

export function AuditFindingsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-display font-bold">Audit Findings</h2>
          <p className="text-muted-foreground">
            Track audit findings and remediation activities
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline">
            <Download className="h-4 w-4 mr-2" />
            Export
          </Button>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Add Finding
          </Button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-4 flex-wrap">
        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Severity</option>
          <option value="critical">Critical</option>
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </select>

        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Status</option>
          <option value="open">Open</option>
          <option value="in-remediation">In Remediation</option>
          <option value="closed">Closed</option>
        </select>

        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search findings..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-border bg-background text-sm"
          />
        </div>

        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Findings Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5" />
            Audit Findings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <Shield className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-medium">No audit findings to display</p>
            <p className="mt-2">
              Audit findings will appear here after they are available from ComplyIQ.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
